import { z } from 'zod/v4';

export const CompanyUnlinkBodySchema = z.object({
  forCompanyId: z.string().min(1).max(4000),
});

export type CompanyUnlinkBody = z.infer<typeof CompanyUnlinkBodySchema>;
